export enum ModuleExtendedEdit {
  CREATE_USER = 1,
  DELETE_USER = 2,
  GENERATE_PASSWORDS = 3,
  EDS_REPORTS_SIGN = 4,
  DELETE_SIGNED_EDS_REPORTS = 5,
  EDIT_SETTINGS = 6,
  CREATE_MESSAGES = 7,
  DATA_EDIT = 8,
  INBOX_EDIT = 11,
  EE_APPROVE_RR_GRADUATES = 12,
  GRANT_REPORT_PERIOD = 13,
  RECALCULATE_CONTINGENT = 14,
  SET_RECALCULATE_DAY = 15,
  PUBLISH_ENROLL_EXAMS = 16,
  PUBLISH_ENROLL_PAYMENT_FORM = 17
}



// WEBPACK FOOTER //
// ./src/app/common/enums/module-extended-edit.enum.ts